import { render, staticRenderFns } from "./SeededRandomDemoQuestion.vue?vue&type=template&id=5061581e&scoped=true&"
import script from "./SeededRandomDemoQuestion.vue?vue&type=script&lang=js&"
export * from "./SeededRandomDemoQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061581e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
